module.exports = __webpack_public_path__ + "img/smartby_favicon_light.9c49deb9.png";